import { baseRouterPath } from "../../utils/constants";
import { mtm_getUtmParamsFromSession } from "../../utils/utility";
import "./style.css";

interface HeaderProps {
  logo: string;
  logoAlt: string;
}

const Header = (props: HeaderProps) => (
  <div id="page-header">
    <header className="px-6 py-3 border-b border-disabled_bg bg-white w-full ln-header">
      <a
        href={
    mtm_getUtmParamsFromSession()
      ? `https://www.lexisnexis.com/en-us/products/nexis-plus-ai.page${mtm_getUtmParamsFromSession()}`
      : "https://www.lexisnexis.com/en-us/products/nexis-plus-ai.page"
  }
        className="ln-logo block"
        data-track="logo-link"
      >
        <img
          src={props.logo}
          alt={props.logoAlt}
          className="max-w-full"
          data-track="logo-image"
        />
      </a>
    </header>
  </div>
);

export default Header;
